import React from "react";
import NetworkPanel from "../components/NetworkPanel.jsx";
import SectionHead from "../components/SectionHead.jsx";
import CtaBand from "../components/CtaBand.jsx";
import VehicleArt from "../components/VehicleArt.jsx";
import Counter from "../components/Counter.jsx";
import Icon from "../components/icons/Icon.jsx";
import Arrow from "../components/icons/Arrow.jsx";
import FEATURES from "../data/features.js";
import SERVICES from "../data/services.js";
import FLEET from "../data/fleet.js";
import STATS from "../data/stats.js";

const Home = ({ go }) => (
  <div className="page">
    <section className="hero">
      <div className="hero-bg" /><div className="hero-grid-lines" />
      <div className="wrap hero-in">
        <div>
          <span className="eyebrow">Transport &amp; logistics · Est. UK</span>
          <h1 className="h-xl">Reliable transport across the <span className="accent">UK &amp; Ireland</span></h1>
          <p className="lead">A4 Express provides dependable courier and heavy goods transportation
            throughout the United Kingdom and Ireland — from a single urgent consignment to
            scheduled contract distribution, moved by our own fleet and our own drivers.</p>
          <div className="hero-cta">
            <button className="btn btn-primary" onClick={() => go("contact")}>Request a quote <Arrow /></button>
            <button className="btn btn-ghost" onClick={() => go("fleet")}>Explore our fleet <Arrow /></button>
          </div>
          <div className="hero-strip">
            <div><span className="k">3.5T – 44T</span><span className="l">Vehicle range</span></div>
            <div><span className="k">Same day</span><span className="l">Courier response</span></div>
            <div><span className="k">UK · NI · ROI</span><span className="l">Operating area</span></div>
          </div>
        </div>
        <div className="reveal"><NetworkPanel /></div>
      </div>
    </section>

    <section className="sec mist">
      <div className="wrap">
        <SectionHead eyebrow="Why choose A4 Express"
          title="Transport you can plan around"
          lead="Every load is handled by our own vehicles and drivers, so the standard you agree is the standard that arrives." />
        <div className="grid g3">
          {FEATURES.map((f) => (
            <article className="card reveal" key={f.t}>
              <div className="ico"><Icon name={f.i} /></div>
              <h3>{f.t}</h3><p>{f.d}</p>
            </article>
          ))}
        </div>
      </div>
    </section>

    <section className="sec">
      <div className="wrap">
        <SectionHead eyebrow="Services" title="One operator, the whole journey"
          lead="Courier work, full loads and contract distribution run from the same operation — so capacity can flex without changing supplier." />
        <div className="grid g3">
          {SERVICES.map((s) => (
            <article className="card svc reveal" key={s.t}>
              <div className="ico"><Icon name={s.i} /></div>
              <h3 dangerouslySetInnerHTML={{ __html: s.t }} />
              <p>{s.d}</p>
              <div className="svc-list">{s.tags.map((t) => <span className="tag" key={t}>{t}</span>)}</div>
            </article>
          ))}
          <article className="card reveal" style={{ background: "var(--indigo-soft)", borderColor: "var(--indigo-line)" }}>
            <div className="ico" style={{ background: "#fff" }}><Icon name="headset" /></div>
            <h3>Not sure which you need?</h3>
            <p style={{ color: "var(--navy)", opacity: .75 }}>Describe the job and we will tell you the right vehicle,
              the realistic timing and what it will cost.</p>
            <button className="btn btn-primary" style={{ marginTop: 22 }} onClick={() => go("contact")}>
              Talk to us <Arrow /></button>
          </article>
        </div>
      </div>
    </section>

    <section className="sec mist">
      <div className="wrap">
        <SectionHead eyebrow="Our fleet" title="The right vehicle for the load"
          lead="Four vehicle types cover everything from an envelope to a full trailer — matched to the consignment, not to what happens to be free." />
        <div className="grid g4">
          {FLEET.map((v) => (
            <article className="veh reveal" key={v.key}>
              <div className="veh-art"><VehicleArt type={v.key} label={v.name} /></div>
              <div className="veh-body">
                <h3>{v.name}</h3>
                <p>{v.short}</p>
                <div className="spec">
                  {v.specs.slice(0, 3).map(([k, val]) => (
                    <div key={k}><span className="st">{k}</span><span className="sv">{val}</span></div>
                  ))}
                </div>
              </div>
            </article>
          ))}
        </div>
        <div style={{ textAlign: "center", marginTop: 48 }} className="reveal">
          <button className="btn btn-primary" onClick={() => go("fleet")}>View the full fleet <Arrow /></button>
        </div>
      </div>
    </section>

    <section className="sec band">
      <div className="wrap">
        <div className="sec-head reveal" style={{ marginBottom: 48 }}>
          <span className="eyebrow" style={{ color: "#A9B2F6" }}>By the numbers</span>
          <h2 className="h-lg">Scale that stays accountable</h2>
        </div>
        <div className="grid g4">
          {STATS.map((s) => (
            <div className="stat reveal" key={s.l}>
              <Counter to={s.v} suffix={s.suffix} />
              <div className="l">{s.l}</div>
            </div>
          ))}
        </div>
      </div>
    </section>

    <CtaBand go={go} />
  </div>
);

export default Home;
